import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=85173c46&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"
import style0 from "./Customer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Customer.vue?vue&type=style&index=1&id=85173c46&lang=scss&scoped=true&"
import style2 from "./Customer.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85173c46",
  null
  
)

export default component.exports